module.exports = __webpack_public_path__ + "img/14.d65d2e02.png";